import request from '../utils/request';
import qs from 'qs';
import RestUrl from '../config/rest-url';

/**
 * 获取验证码
 * @returns
 */
export const getCodeRe = () => {
  return request.request({ url: RestUrl.login.getCode });
};

/**
 * 检验验证码
 * @param {*} data
 * @returns
 */
export const checkCodeRe = (data) => {
  return request.request({
    url: RestUrl.login.checkCode,
    method: 'post',
    params: data,
  });
};

/**
 * 登录
 * @param {*} data
 * @returns
 */
export const loginRe = (data) => {
  let grant_type = 'password';
  const { username, password, code, randomStr } = data;
  let dataObj = qs.stringify({ username: username, password: password });
  return request.request({
    url: RestUrl.login.login,
    headers: {
      isToken: false,
      'TENANT-ID': '1',
      Authorization: 'Basic cGlnOnBpZw==',
    },
    method: 'post',
    params: { randomStr, code, grant_type },
    data: dataObj,
  });
};
